import { useEffect, useState } from "react";
import { api, IDR } from "@/lib/api";
import { toast } from "sonner";

const F = "block text-[10px] tracking-widest text-neutral-500 mb-1";
const I = "w-full bg-transparent border border-[color:var(--border)] p-2 text-sm";

export default function AdminDiscounts() {
  const [codes, setCodes] = useState([]);
  const [f, setF] = useState({ code: "", email: "", percent_off: "", amount_off: "", min_subtotal: 0, expires_days: 90 });
  const load = () => api.get("/admin/discounts").then((r) => setCodes(r.data));
  useEffect(() => { load(); }, []);
  const save = async (e) => {
    e.preventDefault();
    const body = { ...f,
      code: (f.code || "").trim() || null,
      email: (f.email || "").trim() || null,
      percent_off: f.percent_off === "" ? null : Number(f.percent_off),
      amount_off: f.amount_off === "" ? null : Number(f.amount_off),
      min_subtotal: Number(f.min_subtotal || 0),
      expires_days: Number(f.expires_days || 90),
    };
    try { await api.post("/admin/discounts", body); toast.success("Kode dibuat"); load();
      setF({ code: "", email: "", percent_off: "", amount_off: "", min_subtotal: 0, expires_days: 90 });
    } catch (err) { toast.error(err?.response?.data?.detail || "Gagal"); }
  };
  const del = async (id) => { if (!window.confirm("Hapus kode?")) return; await api.delete(`/admin/discounts/${id}`); load(); };
  return (
    <div>
      <h1 className="display text-4xl md:text-6xl mb-6">DISCOUNT CODES</h1>
      <div className="grid md:grid-cols-[1fr,340px] gap-6">
        <div className="border border-[color:var(--border)] overflow-x-auto">
          <table className="w-full text-sm min-w-[700px]">
            <thead className="text-[10px] tracking-widest text-neutral-500"><tr className="border-b border-[color:var(--border)]">
              <th className="p-3 text-left">CODE</th><th className="p-3 text-left">EMAIL</th><th className="p-3 text-left">VALUE</th>
              <th className="p-3 text-left">MIN</th><th className="p-3 text-left">EXPIRES</th><th className="p-3 text-left">STATUS</th><th className="p-3 text-left">SOURCE</th><th></th>
            </tr></thead>
            <tbody>{codes.map((c) => (
              <tr key={c.id} data-testid={`code-row-${c.code}`} className="border-b border-[color:var(--border)]">
                <td className="p-3 mono">{c.code}</td>
                <td className="p-3">{c.email || "—"}</td>
                <td className="p-3">{c.percent_off ? `${c.percent_off}%` : IDR(c.amount_off)}</td>
                <td className="p-3 tabular-nums">{IDR(c.min_subtotal || 0)}</td>
                <td className="p-3 text-xs">{(c.expires_at || "").slice(0,10)}</td>
                <td className="p-3"><span className="status-badge">{c.used_at ? "USED" : "ACTIVE"}</span></td>
                <td className="p-3"><span className="status-badge">{(c.source || "manual").toUpperCase()}</span></td>
                <td className="p-3"><button onClick={() => del(c.id)} className="underline text-[color:var(--accent)] text-xs">Hapus</button></td>
              </tr>))}</tbody>
          </table>
        </div>
        <form onSubmit={save} className="border border-[color:var(--border)] p-4 space-y-3 h-fit">
          <div className="text-[10px] tracking-widest text-neutral-500">NEW CODE</div>
          <div><label className={F}>CODE (opsional)</label><input data-testid="disc-code" className={I} value={f.code} onChange={(e) => setF({ ...f, code: e.target.value })} placeholder="auto: ANIMA-XXXXXX" /></div>
          <div><label className={F}>EMAIL (opsional, batasi ke 1 pelanggan)</label><input data-testid="disc-email" type="email" className={I} value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} /></div>
          <div className="grid grid-cols-2 gap-2">
            <div><label className={F}>PERCENT OFF</label><input data-testid="disc-pct" type="number" min="0" max="100" className={I} value={f.percent_off} onChange={(e) => setF({ ...f, percent_off: e.target.value })} /></div>
            <div><label className={F}>AMOUNT OFF (Rp)</label><input data-testid="disc-amt" type="number" min="0" className={I} value={f.amount_off} onChange={(e) => setF({ ...f, amount_off: e.target.value })} /></div>
          </div>
          <div><label className={F}>MIN SUBTOTAL</label><input type="number" min="0" className={I} value={f.min_subtotal} onChange={(e) => setF({ ...f, min_subtotal: e.target.value })} /></div>
          <div><label className={F}>EXPIRES (days)</label><input type="number" min="1" className={I} value={f.expires_days} onChange={(e) => setF({ ...f, expires_days: e.target.value })} /></div>
          <button data-testid="disc-save" className="w-full bg-white text-black py-2 text-xs tracking-widest">CREATE</button>
          <p className="text-[10px] text-neutral-500">Loyalty codes akan otomatis dibuat setelah order berbayar ke-2 dari email yang sama.</p>
        </form>
      </div>
    </div>
  );
}
